import { SecondaryButton } from 'components';

export default function AuditInviteButton({ openInvite, onOpenInvite }) {
	return (
		<SecondaryButton onClick={onOpenInvite}>
			{openInvite ? 'cancel' : 'Create Link'}
		</SecondaryButton>
	);
}
